import { render, staticRenderFns } from "./RejectDraftContract.vue?vue&type=template&id=cb834bd8"
import script from "./RejectDraftContract.vue?vue&type=script&lang=js"
export * from "./RejectDraftContract.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports